











































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SelectColorComponent from './SelectColorComponent.vue';
import {
  TypographyModel,
  ResponsiveSizes,
  ComponentModel,
  Dictionary
} from '@/models';

@Component({
  components: {
    SelectColorComponent
  }
})
export default class TypographyCss extends Vue {
  @Prop()
  size!: ResponsiveSizes;

  @Prop()
  model!: ComponentModel;

  invalidTypes: string[];

  constructor() {
    super();
    this.invalidTypes = ['Check', 'Column', 'Container', 'Grid'];
  }

  get typographyCss() {
    if (!this.model || !this.isValidModel) return null;

    return this.model.getCss<TypographyModel>('typography', this.size);
  }

  get isValidModel(): boolean {
    return this.invalidTypes.indexOf(this.model.typeName) < 0;
  }

  setTextColor(color: string) {
    this.typographyCss!.textColor.color = color;
  }

  setHoverColor(color: string) {
    this.typographyCss!.textColor.hover = color;
  }
}
